import Table from "react-bootstrap/Table";

interface DashboardTableProps {
    children: React.ReactNode
}

export const DashboardTable = ({children} : DashboardTableProps) => {
    return (
        <Table className="caption-top align-top" hover responsive>
            <tbody>
                {children}
            </tbody>
        </Table>
    )
}